import React from "react";
import Text from "@amzn/meridian/text";
var KeyTermContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ React.createElement(Text, {
        tag: "ul"
    }, content.map(function(keyTerm) {
        return /*#__PURE__*/ React.createElement("li", null, keyTerm.term, " - ", keyTerm.description);
    }));
};
export default KeyTermContent;

//# sourceMappingURL=KeyTermContent.js.map